/**
 * TASK COMPLETION TOGGLE — il "pallino" cliccabile che completa / ri-mette da
 * completare un task. Tre stati visuali (classi in _components.scss):
 *  - completato: spunta su cerchio verde pieno
 *  - scaduto (non completato): spunta grigia, bordo del cerchio rosso
 *  - altrimenti: cerchio vuoto ("da completare").
 *
 * Riusato nella timeline attività (ActivityTimeline) e nella tabella Task
 * (TaskList). stopPropagation: il toggle vive dentro contenitori cliccabili
 * (AccordionSummary / row della DataGrid), senza fermare l'evento il click
 * espanderebbe il pannello o aprirebbe il drawer invece di completare il task.
 */

import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import type { Task } from './taskTypes';
import { isTaskCompleted, isTaskExpired } from './taskStatus';

interface TaskCompletionToggleProps {
  task: Task;
  onToggle: () => void;
}

export function TaskCompletionToggle({ task, onToggle }: TaskCompletionToggleProps) {
  const { t } = useTranslation();
  const completed = isTaskCompleted(task);
  const expired = isTaskExpired(task);
  const state = completed ? 'completed' : expired ? 'expired' : 'todo';
  const aria = completed ? t('activity.markTodo') : t('activity.markCompleted');
  return (
    <button
      type="button"
      className={`task-completion task-completion--${state}`}
      aria-label={aria}
      aria-pressed={completed}
      title={aria}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      {(completed || expired) && (
        <CheckIcon className="task-completion__check" fontSize="inherit" />
      )}
    </button>
  );
}